export function numberIsFinite(n: unknown): n is number {
  return Number.isFinite(n);
}
